"use client";
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { Swatch } from "timvir/blocks";
import { useBlock } from "timvir/core";
import { layoutStyles } from "../../core/layout";
import { cx } from "../../internal/cx";
/**
 * The underlying DOM element which is rendered by this component.
 */ const Root = "div";
export function ColorBar(props) {
    const block = useBlock(props);
    const { values, ...rest } = block.props;
    const [selected, setSelected] = React.useState(undefined);
    const rootStyleProps = stylex.props(layoutStyles.block, styles.root);
    return <Root {...rest} {...rootStyleProps} className={cx(rest.className, rootStyleProps.className)} style={{
        ...rootStyleProps.style,
        ...rest.style
    }}>
      <div className="xrvj5dj x1sdr0u7 xdz4c1r" style={{
        opacity: selected ? 0 : 1
    }}>
        {values.map((value, i, self)=><div key={i} className="x1vqgdyp x1iyjqo2 xrvj5dj x13b6k1y x1ypdohk xzkaem6 x12l46wj xinzabm x1bxid8z">
            <div {...{
            0: {
                className: "xzhuw26 xnfsnhl x1ehn4u0 x32zglm"
            },
            2: {
                className: "x16gz6n8 xzhuw26 xnfsnhl x1ehn4u0 x32zglm"
            },
            1: {
                className: "xbtcsfn xzhuw26 xnfsnhl x1ehn4u0 x32zglm"
            },
            3: {
                className: "xbtcsfn xzhuw26 xnfsnhl x1ehn4u0 x32zglm"
            }
        }[!!(i === 0) << 1 | !!(i === self.length - 1) << 0]} style={{
            background: typeof value === "string" ? value : value.value
        }} onClick={()=>{
            setSelected(value);
        }}/>
          </div>)}
      </div>

      {selected !== undefined && <div className="x10l6tqk xwa60dl x3m8u43 xu96u03 x1cb1t30 xoegz02">
          <Swatch {...typeof selected === "string" ? {
        value: selected
    } : {
        value: selected.value
    }} style={{
        margin: 0
    }} onMouseLeave={()=>{
        setSelected(undefined);
    }}/>
        </div>}
    </Root>;
}
const styles = {
    root: {
        kVAEAm: "x1n2onr6",
        $$css: true
    }
};
